import { render, staticRenderFns } from "./agenda-days-filter.vue?vue&type=template&id=65dfe656&"
import script from "./agenda-days-filter.vue?vue&type=script&lang=js&"
export * from "./agenda-days-filter.vue?vue&type=script&lang=js&"
import style0 from "./agenda-days-filter.vue?vue&type=style&index=0&id=65dfe656&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports